import { PageHeader } from 'Common';
import AccountSettingsTabs from 'Components/Dashboard/AccountSettingsTabs';
import DashboardBody from 'Components/Dashboard/DashboardBody';
import DashboardVerificationBannerContainer from 'Components/Dashboard/DashboardVerificationBannerContainer';
import CONFIG from 'Config/settings';
import DynamicNotificationsContainer from 'Notifications/DynamicNotifications/DynamicNotificationsContainer';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { t } from 'Utils/localization/i18next';
import DynamicNotification from '../_notifications/DynamicNotification';
import styles from './DashboardRegularContainer.module.scss';
import UpgradeToFamilyCard from './UpgradeToFamilyCard';

const DashboardRegularContainer = props => {
  return (
    <React.Fragment>
      <DashboardVerificationBannerContainer />
      <DashboardBody>
        <div className={styles['notifications-container']}>
          <DynamicNotificationsContainer id="regular-dashboard-notifications" />
          {CONFIG.FEATURE.REGULAR_DASHBOARD.SHOW_PREFERENCES && (
            <DynamicNotification
              allowEmail={props.allowEmail}
              allowSMS={props.allowSMS}
              allowDirectMail={props.allowDirectMail}
              allowPhone={props.allowPhone}
            />
          )}
        </div>
        <div id="account-settings">
          <PageHeader>
            {t(`dashboard.account-settings.header.title`)}
          </PageHeader>
          <UpgradeToFamilyCard />
          <AccountSettingsTabs profileType={props.profileType} />
        </div>
      </DashboardBody>
    </React.Fragment>
  );
};

DashboardRegularContainer.propTypes = {
  payments: PropTypes.array,
  isPaymentsEnabled: PropTypes.bool,
  profileType: PropTypes.string,

  allowEmail: PropTypes.bool,
  allowSMS: PropTypes.bool,
  allowDirectMail: PropTypes.bool,
  allowPhone: PropTypes.bool
};

const mapStateToProps = state => {
  const payments = state.payment.payments || [];
  return {
    allowEmail: state.profile.allowEmail,
    allowSMS: state.profile.allowSMS,
    allowDirectMail: state.profile.allowDirectMail,
    allowPhone: state.profile.allowPhone,
    profileType: state.profile.profileType,
    payments,
    isPaymentsEnabled:
      CONFIG.FEATURE.REGULAR_DASHBOARD.ENABLE_PAYMENTS_TAB &&
      payments.length > 0
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(DashboardRegularContainer)
);
